module.exports = __webpack_public_path__ + "static/media/fly0193.31f47744.webp";